<script>
import baseMixin from '@/mixins/baseMixin'
import CommentModel from '@/models/comments/commentModel'
// import CommentType from '@/constants/comments/CommentType'
import CommentDefault from './comment-default.vue'

export default {
  name: 'CommentControl',
  mixins: [baseMixin],
  props: {
    comment: {
      type: CommentModel,
      required: true,
    },
  },
  data: () => {
    return {}
  },
  computed: {
    commentControlDefinition() {
      switch (this.comment.type) {
        // TODO: Add comment control types when required
        // e.g.
        // case CommentType.BookingUpdated:
        //   return this.commentControlFactory(CommentBookingUpdated)
        default:
          return this.commentControlFactory(CommentDefault)
      }
    },
  },
  methods: {
    commentControlFactory(component, extraProps = {}) {
      return {
        component,
        props: {
          ...extraProps,
          comment: this.comment,
        },
        events: {},
      }
    },
  },
}
</script>

<template>
  <component
    :is="commentControlDefinition.component"
    v-if="commentControlDefinition"
    data-testid="comment-control-component"
    :data-type="comment.type"
    v-bind="commentControlDefinition.props"
    v-on="commentControlDefinition.events"
  />
</template>
